import React from "react";
import "./LandscapeSlideshow.css";

// Match the public pages' asset base in Vite and in FastAPI.
const landingAssetBase = import.meta.env.DEV
  ? `${import.meta.env.BASE_URL}brand/landing/`
  : "/brand/landing/";

const LANDSCAPE_IMAGES = [
  "montreal-grain-truck-transia.png",
  "Camion Meunerie.png",
  "Camion Gavel.png",
  "Camion_dans_entrepot.png",
  "montreal-truck-photo-selection.png",
  "Camion ferme.png",
  "Camion campagne.png",
];
const LANDSCAPE_SLIDE_MS = 6600; // 5 s visible + 1.6 s crossfade

// Rendered inside a positioned landscape container; the active photo fades in over the previous one.
export default function LandscapeSlideshow() {
  const [slide, setSlide] = React.useState(() => ({
    current: Math.floor(Math.random() * LANDSCAPE_IMAGES.length),
    previous: null,
  }));

  React.useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    const timer = window.setInterval(() => {
      setSlide(({ current }) => ({ current: (current + 1) % LANDSCAPE_IMAGES.length, previous: current }));
    }, LANDSCAPE_SLIDE_MS);
    return () => window.clearInterval(timer);
  }, []);

  return LANDSCAPE_IMAGES.map((fileName, index) => {
    const stateClass = index === slide.current ? " is-active" : index === slide.previous ? " is-previous" : "";
    return (
      <img
        key={fileName}
        className={`landscape-slide${stateClass}`}
        src={`${landingAssetBase}${encodeURIComponent(fileName)}`}
        alt=""
        width={1672}
        height={941}
        fetchpriority={index === slide.current ? "high" : undefined}
        loading="eager"
        decoding="async"
      />
    );
  });
}
